function disableReactDevTools() {
    // console.log('reactDevTools disabled ')
    if (window && window.__REACT_DEVTOOLS_GLOBAL_HOOK__ && window.location.hostname !== "localhost") {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {};
    }
};

export {
    disableReactDevTools
}